import styled from "@emotion/styled";
import { Modal } from "react-bootstrap";
import { IStyledComponentProps } from "../../../../theme/theme.types";

const PackageSelectorPopOut = styled.div<IStyledComponentProps>`
  &.package-selector-popout {
    .package-list-item {
      box-shadow: none;
      border: 1px solid ${(props) => props.theme.colors.grays.tertiary};
    }
  }
`;

const PackageSelectorModal = styled(Modal)<IStyledComponentProps>`
  .package-selector-modal {
    .modal-content {
      .modal-body {
        padding: 0;
        overflow-y: scroll;
      }
      .modal-footer {
        button.back-button {
          width: 100%;
        }
      }
    }

    &.lg {
      .modal-content {
        height: ${(window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight) - 30}px;
      }
    }
  }
`;

const PackageSelectorModalHeader = styled(Modal.Header)<IStyledComponentProps>`
  &.package-selector-modal-header {
  }
`;

export default {
  PackageSelectorPopOut,
  PackageSelectorModal,
  PackageSelectorModalHeader,
};
